<template class="mr-3">
  <div class="card">
    <div class="card-body">
      <div class="filters-section">
        <div class="filters-header">
          <h4>
            <a-icon type="filter" class="filter-icon" />
            {{ $t("all.filtresEtRecherche") }}
          </h4>
          <div class="action-button-group">
            <a-dropdown :disabled="pdfLoading">
              <a-menu slot="overlay">
                <a-menu-item
                  key="3"
                  @click="generatePdf"
                  :class="{
                    disabledPack: !btnAccessGetter.includes('pEtatImp'),
                  }"
                >
                  <a-icon type="file-pdf" /> {{ $t("action.imprimerTab") }}
                </a-menu-item>
                <a-menu-item
                  key="1"
                  @click="generatePdfScolarite"
                  :class="{
                    disabledPack:
                      !btnAccessGetter.includes('pEtatImpScolarite'),
                  }"
                >
                  <i class="fa fa-graduation-cap"></i>
                  {{ $t("menu.etatImpayes") }} - {{ $t("menu.scolarite") }}
                </a-menu-item>
                <a-menu-item
                  key="2"
                  @click="generatePdfActivites"
                  :class="{
                    disabledPack: !btnAccessGetter.includes('pEtatImpAct'),
                  }"
                >
                  <i class="fa fa-tags"></i> {{ $t("menu.etatImpayes") }} -
                  {{ $t("menu.activites") }}
                </a-menu-item>
              </a-menu>
              <a-button
                :loading="pdfLoading"
                :disabled="pdfLoading"
                icon="file-pdf"
                type="primary"
                class="action-button"
              >
                {{ $t("action.imprimer") }}
                <a-icon type="down" />
              </a-button>
            </a-dropdown>

            <a-button
              :class="{
                disabledPack: !btnAccessGetter.includes('pEtatImpCSV'),
              }"
              :disabled="!btnAccessGetter.includes('pEtatImpCSV')"
              @click="exportToExcel"
            >
              <a-icon type="file-excel" class="text-success action-icon" />
              <span>Excel</span>
            </a-button>
          </div>
        </div>

        <a-row :gutter="[16, 16]" class="align-items-end">
          <a-col v-if="hasMonthlyMode" :xs="24" :sm="12" :md="8" :lg="8">
            <div class="filter-item">
              <label class="filter-label">
                <a-icon type="calendar" class="action-icon" />
                {{ $t("recette.mois") }}
              </label>
              <a-select
                id="selectMonth"
                show-search
                :placeholder="$t('recette.tousMois')"
                option-filter-prop="children"
                class="filter-select"
                :filter-option="filterOption"
                @change="handleChangeSelectMois"
              >
                <a-select-option value="all">
                  {{ $t("recette.tousMois") }}
                </a-select-option>
                <a-select-option value="inscription">
                  {{ $t("liste.inscription") }}
                </a-select-option>
                <a-select-option
                  v-for="(m, index) in monthsArr"
                  :key="index + 1"
                  :value="index + 1"
                >
                  {{ m }}
                </a-select-option>
              </a-select>
            </div>
          </a-col>
          <a-col v-if="hasTranchesMode" :xs="24" :sm="12" :md="8" :lg="8">
            <div class="filter-item">
              <label class="filter-label">
                <a-icon type="calendar" class="action-icon" />
                {{ $t("liste.tranches") }}
              </label>
              <a-select
                id="selectTranche"
                :placeholder="$t('liste.toutesTranches')"
                class="filter-select"
                @change="handleChangeSelectTranche"
              >
                <a-select-option value="all">
                  {{ $t("liste.toutesTranches") }}
                </a-select-option>
                <a-select-option value="inscription">
                  {{ $t("liste.inscription") }}
                </a-select-option>
                <a-select-option
                  v-for="t in trancheOptions"
                  :key="t.value"
                  :value="t.value"
                >
                  {{ t.label }}
                </a-select-option>
              </a-select>
            </div>
          </a-col>
        </a-row>
      </div>

      <div class="table-container">
        <a-table
          @change="tableChanged"
          rowKey="_id"
          :loading="loadingData"
          :pagination="true"
          :data-source="data"
          :columns="columns"
          :row-class-name="getRowClassName"
        >
          <template
            slot="expandedRowRender"
            slot-scope="record"
            v-if="showThisRow(record)"
          >
            <table class="table table-striped">
              <thead>
                <th>{{ $t("recette.mois") }}</th>
                <th>{{ $t("recette.montantRestant") }}</th>
              </thead>
              <tbody>
                <tr
                  v-for="(fee, key) in record.fees"
                  :key="key"
                  v-if="fee.feeAfterReduction > 0"
                >
                  <td>
                    {{ formatFeeName(fee.feeName, record.daily) }}
                  </td>
                  <td>
                    <div v-if="!fee.fullyPaid">
                      <div v-if="fee.remaining && fee.remaining > 0">
                        <span class="amount-cell">{{ fee.remaining }}</span>
                        <a-tag color="orange">
                          {{ $t("profil.paidWithAvance") }}
                        </a-tag>
                      </div>
                      <div v-else>
                        <del v-if="fee.repReductionValue > 0">
                          <span class="amount-cell">{{
                            fee.feeBeforeRed
                          }}</span>
                        </del>
                        <div v-else>
                          <span class="amount-cell">{{
                            fee.feeAfterReduction
                          }}</span>
                        </div>
                        <sup
                          v-if="fee.repReductionValue > 0"
                          class="text-success"
                          >-{{ fee.repReductionValue }}%</sup
                        >
                        <div v-if="fee.repReductionValue > 0">
                          =<span class="amount-cell">{{
                            fee.feeAfterReduction
                          }}</span>
                        </div>
                      </div>
                    </div>
                    <div v-else><span class="amount-cell">0</span></div>
                  </td>
                </tr>
              </tbody>
            </table>
          </template>
          <template slot="parent" slot-scope="text, record">
            {{ record.parent.fatherName }}
            <br />

            {{ record.parent.motherName }}
          </template>
          <template slot="mode" slot-scope="text">
            <a-tag color="#3498db" v-if="text == 'M'">
              {{ $t("encaissement.monthlyPayment") }}
            </a-tag>
            <a-tag color="#27ae60" v-else>
              {{ $t("encaissement.installmentPayment") }}
            </a-tag>
          </template>
          <template slot="phone" slot-scope="text, record">
            {{ record.parent.fatherPhone }}<br />
            {{ record.parent.motherPhone }}
          </template>
          <template slot="student" slot-scope="text, record">
            {{ record.student }}
          </template>
          <template slot="typeAS" slot-scope="text, record">
            <div>
              {{
                text == "activity"
                  ? $t("encaissement.activity") + ": "
                  : $t("encaissement.schooling") + ": "
              }}{{ record.name }}
            </div>
          </template>
          <!--
      <template
        v-for="col in [
          'nomClient',
          'telephone',
          'enfant',
          'frais',
          'montant',
        ]"
        :slot="col"
        slot-scope="text, record"
      >
        <div :key="col">
          <a-input
            v-if="record.editable"
            style="margin: -5px 0"
            :value="text"
            @change="(e) => handleChange(e.target.value, record.key, col)"
          />
          <template v-else>{{ text }}</template>
        </div>
      </template>
      -->
          <div
            slot="filterDropdown"
            slot-scope="{
              setSelectedKeys,
              selectedKeys,
              confirm,
              clearFilters,
              column,
            }"
            style="padding: 8px"
          >
            <a-input
              v-ant-ref="(c) => (searchInput = c)"
              :placeholder="`${$t('personnel.chercher')} ${column.title}`"
              :value="selectedKeys[0]"
              style="width: 188px; margin-bottom: 8px; display: block"
              @change="
                (e) => setSelectedKeys(e.target.value ? [e.target.value] : [])
              "
              @pressEnter="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
            />
            <a-button
              type="primary"
              icon="search"
              size="small"
              style="width: 90px; margin-right: 8px"
              @click="
                () => handleSearch(selectedKeys, confirm, column.dataIndex)
              "
              >{{ $t("paiement.chercher") }}</a-button
            >
            <a-button
              size="small"
              style="width: 90px"
              @click="() => handleReset(clearFilters)"
              >{{ $t("action.reinitialiser") }}</a-button
            >
          </div>
          <a-icon
            slot="filterIcon"
            slot-scope="filtered"
            type="search"
            :style="{ color: filtered ? '#108ee9' : undefined }"
          />
          <template
            slot="customRender"
            slot-scope="text, record, index, column"
          >
            <span v-if="searchText && searchedColumn === column.dataIndex">
              <template
                v-for="(fragment, i) in text
                  .toString()
                  .split(
                    new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i')
                  )"
              >
                <mark
                  v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                  :key="i"
                  class="highlight"
                  >{{ fragment }}</mark
                >
                <template v-else>{{ fragment }}</template>
              </template>
            </span>
            <template v-else>{{ text }}</template>
          </template>
          <template slot="delete" slot-scope="text, record">
            <a-popconfirm
              :title="$t('all.sureToDelete')"
              @confirm="() => onDelete(record.key)"
            >
              <a-button type="danger">
                <a-icon type="delete" href="javascript:;" />{{
                  $t("action.supprimer")
                }}
              </a-button>
            </a-popconfirm>
          </template>
        </a-table>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import apiClient from "@/services/axios";
import { mapState, mapActions, mapGetters } from "vuex";
import * as XLSX from "xlsx";
import _ from "lodash";
import moment from "moment";
import { formatFeeName } from "@/utilities/settings";
import { PdfGenerator } from "./pdfGenerator";

export default {
  async created() {
    this.monthsArr = moment.months();
    this.loadingData = true;

    await this.getPaymants();

    this.loadingData = false;

    this.cacheData = this.data.map((item) => ({ ...item }));
    this.filtredTable = this.data;

    this.schoolType = this.user.building.filter(
      (el) => el.dbName == this.settings.activeBuilding
    )[0].type;
    if (!this.schoolType)
      notification.warning({
        message: this.$t("bulletin.typeIntrouvable"),
        description: this.$t("bulletin.saisirSchoolType"),
      });

    this.schoolDetails = this.user.building.filter(
      (el) => el.dbName == this.settings.activeBuilding
    )[0];
    let { start, end } = this.settings.schoolarYears.find(
      (el) => el._id == this.settings.activeSchoolarYear
    );

    start = new Date(start).getFullYear();
    end = new Date(end).getFullYear();

    this.schoolarYearName = end + " - " + start;

    // Initialize PDF generator
    this.pdfGenerator = new PdfGenerator(this);
  },
  computed: {
    ...mapState(["settings", "user"]),
    ...mapGetters("settings", ["btnAccessGetter"]),

    csvExportTable() {
      try {
        if (!this.btnAccessGetter.includes("pEtatImpCSV")) return [];

        const exportData = [];

        const modifiedData = [...this.filtredTable];

        modifiedData.forEach((paymentRow) => {
          if (paymentRow.parent && paymentRow.student && paymentRow.fees) {
            let monthsUnpaied = 0;
            for (let fee of paymentRow.fees) {
              if (fee.fullyPaid === false) monthsUnpaied++;
            }

            // Add all unpaid fees for this enrollment
            for (let fee of paymentRow.fees) {
              if (fee.fullyPaid === false) {
                const feeName = formatFeeName(fee.feeName, paymentRow.daily);
                const frais = feeName + " - " + paymentRow.name;
                const feeAmount = (fee.remaining && !isNaN(fee.remaining))
                  ? fee.remaining
                  : (fee.feeAfterReduction && !isNaN(fee.feeAfterReduction))
                    ? fee.feeAfterReduction
                    : 0;

                exportData.push({
                  nomClient: paymentRow.parent.fatherName,
                  telephone: paymentRow.parent.fatherPhone,
                  enfant: paymentRow.student,
                  frais: frais,
                  montant: parseFloat(feeAmount).toFixed(3)
                });
              }
            }
          }
        });

        return exportData;
      } catch (error) {
        console.error("Error generating Excel export:", error);
        return [];
      }
    },

    columns() {
      return [
        {
          title: this.$t("recette.nom"),
          dataIndex: "parent",
          key: "parent",
          width: "150px",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "parent",
          },
          onFilter: (value, record) => {
            let clientName =
              record.parent.fatherName + " " + record.parent.motherName;
            return clientName.toLowerCase().includes(value.toLowerCase());
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },

        {
          title: this.$t("recette.telephone"),
          dataIndex: "parent",
          key: "phone",
          width: "150px",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "phone",
          },
          onFilter: (value, record) =>
            (record.parent.fatherPhone + " " + record.parent.motherPhone)
              .toLowerCase()
              .includes(value.toLowerCase()),
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("recette.enfant"),
          dataIndex: "student",
          key: "student",
          width: "150px",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "student",
          },
          onFilter: (value, record) => {
            return record.student.toLowerCase().includes(value.toLowerCase());
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("encaissement.fees"),
          dataIndex: "typeAS",
          key: "typeAS",
          width: "300px",
          scopedSlots: {
            filterDropdown: "filterDropdown",
            filterIcon: "filterIcon",
            customRender: "typeAS",
          },
          onFilter: (value, record) => {
            const getType = (typeR, r) => {
              return (
                (typeR == "activity"
                  ? this.$t("encaissement.activity") + ": "
                  : this.$t("encaissement.schooling") + ": ") + r.name
              );
            };
            return getType(record.type, record)
              .toLowerCase()
              .includes(value.toLowerCase());
          },
          onFilterDropdownVisibleChange: (visible) => {
            if (visible) {
              setTimeout(() => {
                this.searchInput.focus();
              });
            }
          },
        },
        {
          title: this.$t("encaissement.paymentMethod"),
          dataIndex: "mode",
          key: "mode",
          width: "150px",
          scopedSlots: {
            customRender: "mode",
          },
          filters: [
            { text: this.$t("encaissement.monthly"), value: "M" },
            { text: this.$t("encaissement.installments"), value: "T" },
          ],

          onFilter: (value, record) => record.mode.indexOf(value) === 0,
        },
      ];
    },
  },
  data() {
    return {
      pdfLoading: false,
      pdfGenerator: null,
      monthsArr: [],
      labels: {
        nomclient: "Nom client",
        telephone: "Telephone",
      },
      fields: ["nomClient", "telephone", "enfant", "frais", "montant"],
      mF: true,
      selectedMonth: "all",
      selectedTranche: "all",
      trancheOptions: [],
      hasMonthlyMode: false,
      hasTranchesMode: false,
      rowData: [],
      editingKey: "",
      students: [],
      visibleParentFile: false,
      data: [],
      searchText: "",
      searchInput: null,
      searchedColumn: "",
      targetKeys: [],
      previewVisible: false,
      previewImage: "",
      value: 1,
      loadingData: false,
      visibleData: false,
      indeterminate: true,
      checkAll: false,
      filtredTable: [],
    };
  },
  methods: {
    ...mapActions("settings", ["packHasBtnAccess"]),
    moment,
    formatFeeName,
    //show row if at least one fee is unpaid
    showThisRow(record) {
      for (const fee of record.fees) {
        if (!fee.fullyPaid) return true;
      }
      return false;
    },
    tableChanged(pagination, filters, sorter, extra) {
      this.filtredTable = extra.currentDataSource;
    },

    filterOption(input, option) {
      return (
        option.componentOptions.children[0].text
          .toLowerCase()
          .indexOf(input.toLowerCase()) >= 0
      );
    },
    handleSearch(selectedKeys, confirm, dataIndex) {
      confirm();
      this.searchText = selectedKeys[0];
      this.searchedColumn = dataIndex;
    },
    handleReset(clearFilters) {
      clearFilters();
      this.searchText = "";
    },
    async generatePdf() {
      if (this.pdfGenerator) {
        await this.pdfGenerator.generatePdf();
      }
    },
    async generatePdfScolarite() {
      if (this.pdfGenerator) {
        await this.pdfGenerator.generatePdfScolarite();
      }
    },
    async generatePdfActivites() {
      if (this.pdfGenerator) {
        await this.pdfGenerator.generatePdfActivites();
      }
    },
    exportToExcel() {
      try {
        const exportData = this.csvExportTable.filter((item) =>
          item && Object.keys(item).length > 0 && item.nomClient && item.telephone && item.enfant && item.frais && item.montant
          );

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(exportData);

        // Map column headers to proper labels (matching PDF format)
        const headerMap = {
          nomClient: this.$t("recette.nom"),
          telephone: this.$t("recette.telephone"),
          enfant: this.$t("recette.enfant"),
          frais: this.$t("encaissement.fees"),
          montant: this.$t("recette.montant")
        };

        // Rename headers
        const range = XLSX.utils.decode_range(worksheet['!ref']);
        for (let C = range.s.c; C <= range.e.c; ++C) {
          const address = XLSX.utils.encode_cell({ c: C, r: 0 });
          const cell = worksheet[address];
          if (cell && headerMap[cell.v]) {
            cell.v = headerMap[cell.v];
          }
        }

        const mergeArray = [];
        let rowIndex = 2; // Start from row 2 (after header)

        // Iterate through filtredTable to identify enrollment blocks
        for (const paymentRow of this.filtredTable) {
          if (paymentRow.parent && paymentRow.student && paymentRow.fees) {
            const unpaidFees = paymentRow.fees.filter(fee => fee.fullyPaid === false);

            // If this enrollment has multiple unpaid fees, merge the first 3 columns
            if (unpaidFees.length > 1) {
              const startRow = rowIndex;
              const endRow = rowIndex + unpaidFees.length - 1;

              for (let col = 0; col < 3; col++) {
                mergeArray.push({
                  s: { r: startRow - 1, c: col },
                  e: { r: endRow - 1, c: col }
                });
              }
            }

            rowIndex += unpaidFees.length;
          }
        }

        // Apply cell merges
        if (!worksheet['!merges']) worksheet['!merges'] = [];
        worksheet['!merges'] = mergeArray;

        // Set column widths (matching PDF layout)
        const columnWidths = [
          { wch: 30 }, // Nom client
          { wch: 25 }, // Téléphone
          { wch: 25 }, // Enfant
          { wch: 40 }, // Frais
          { wch: 15 }, // Montant
        ];
        worksheet['!cols'] = columnWidths;

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, this.$t("encaissement.stateOfUnpaid"));

        // Export to Excel file
        XLSX.writeFile(workbook, "etatDesImpayés.xlsx");
        this.$message.success(this.$t("success.excelGenerated"));
      } catch (error) {
        console.error("Error generating Excel export:", error);
      }
    },
    handleChangeSelectMois(value) {
      this.selectedMonth = value;
      const rowData = [...this.rowData];
      if (value == "all") {
        this.mF = true;
        this.data = rowData;
      } else if (value == "inscription") {
        this.mF = false;
        const bothInscription = this.selectedTranche === "inscription";
        this.data = rowData
          .filter((elem) => elem.fees && elem.fees.length > 0)
          .filter((elem) => bothInscription || elem.mode === "M")
          .map((elem) => ({
            ...elem,
            fees: elem.fees.filter((f) => f.feeName === "inscription"),
          }))
          .filter((elem) => elem.fees.length > 0 && this.showThisRow(elem));
      } else {
        this.mF = false;
        this.data = rowData
          .filter((elem) => elem.fees.length > 0)
          .map((elem) => {
            const fees = [...elem.fees];
            let newFees = fees.filter((fee) => {
              if (fee.feeName == "inscription") return false;
              if (elem.mode == "M") {
                if (parseInt(fee.feeName.split("-")[1]) == parseInt(value))
                  return true;
              } else {
                const tranche = elem.tranchesFee
                  ? elem.tranchesFee.find(
                      (t) => t.trancheNumber == fee.feeName
                    )
                  : null;
                const trancheMonths = tranche ? tranche.months || [] : [];
                if (trancheMonths.includes(parseInt(value))) return true;
              }
            });
            return { ...elem, fees: newFees };
          })
          .filter((elem) => elem.fees.length > 0 && this.showThisRow(elem));
      }
      if (this.selectedTranche && this.selectedTranche !== "all") {
        this.applyTrancheFilter();
      } else {
        this.filtredTable = this.data;
      }
    },
    handleChangeSelectTranche(value) {
      this.selectedTranche = value;
      const month = this.selectedMonth || "all";
      this.handleChangeSelectMois(month);
    },
    applyTrancheFilter() {
      if (!this.selectedTranche || this.selectedTranche === "all") {
        this.filtredTable = this.data;
        return;
      }
      const trancheValue = this.selectedTranche;
      const bothInscription = this.selectedMonth === "inscription" && trancheValue === "inscription";
      const filtered = this.data
        .map((row) => {
          if (!row.fees || !row.fees.length) return { ...row, fees: [] };
          if (trancheValue === "inscription") {
            const fees = row.fees.filter((fee) => fee.feeName === "inscription");
            return { ...row, fees };
          }
          if (row.mode !== "T") return { ...row, fees: [] };
          const fees = row.fees.filter((fee) => fee.feeName == trancheValue);
          return { ...row, fees };
        })
        .filter((row) => {
          if (trancheValue !== "inscription") return row.fees && row.fees.length > 0;
          return row.fees && row.fees.length > 0 && (bothInscription || row.mode === "T");
        });
      this.data = filtered;
      this.filtredTable = filtered;
    },
    async getPaymants() {
      await apiClient.get("/payment/etatImpaye").then((res) => {
        this.data = res.data;
        this.rowData = res.data;
        this.buildTrancheOptions();
        this.computeModesPresence();
      });
    },
    buildTrancheOptions() {
      const tranchesSet = new Set();
      this.rowData.forEach((row) => {
        if (row.tranchesFee && row.tranchesFee.length) {
          row.tranchesFee.forEach((t) => {
            if (t && t.trancheNumber != null) {
              tranchesSet.add(t.trancheNumber);
            }
          });
        }
      });
      this.trancheOptions = Array.from(tranchesSet)
        .sort((a, b) => a - b)
        .map((num) => ({
          value: String(num),
          label: `${this.$t("paiement.trancheLabel")} ${num}`,
        }));
    },
    computeModesPresence() {
      let hasM = false;
      let hasT = false;
      this.rowData.forEach((row) => {
        if (row.mode === "M") hasM = true;
        if (row.mode === "T") hasT = true;
      });
      this.hasMonthlyMode = hasM;
      this.hasTranchesMode = hasT;
    },

    getRowClassName(record, index) {
      return index % 2 === 0 ? "table-row-even" : "table-row-odd";
    },
  },
};
</script>

<style>
@import "../../common.css";

/* Component-specific enhancements */
.form-label {
  font-weight: 600;
  color: #495057;
  font-size: 0.875rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

/* Card improvements */
.card {
  border: none;
  border-radius: 8px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.card-body {
  padding: 1.5rem;
}

/* Ant Design component improvements */
.ant-btn {
  border-radius: 6px;
  font-weight: 500;
  height: 36px;
  padding: 0 16px;
}

.ant-btn-primary {
  background: linear-gradient(135deg, #1890ff 0%, #096dd9 100%);
  border: none;
}

.ant-btn-primary:hover {
  background: linear-gradient(135deg, #40a9ff 0%, #1890ff 100%);
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(24, 144, 255, 0.3);
}

.ant-btn-default {
  border: 1px solid #d9d9d9;
  background: #fff;
}

.ant-btn-default:hover {
  border-color: #1890ff;
  color: #1890ff;
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.ant-select {
  border-radius: 6px;
}

.ant-select-focused .ant-select-selector {
  border-color: #1890ff;
  box-shadow: 0 0 0 2px rgba(24, 144, 255, 0.2);
}

.ant-select-selector {
  height: 36px !important;
  line-height: 36px !important;
}

/* Table improvements */
.ant-table {
  border-radius: 6px;
  overflow: hidden;
}

.ant-table-thead > tr > th {
  background-color: #f8f9fa;
  border-bottom: 2px solid #e9ecef;
  font-weight: 600;
  color: #495057;
}

.ant-table-tbody > tr:hover > td {
  background-color: #f8f9fa;
}
</style>
